var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttachment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "attachment-alt",
    d: "M8.638,4.928H10V15.354a4.841,4.841,0,0,1-1.468,3.553A4.812,4.812,0,0,1,5,20.375a4.818,4.818,0,0,1-3.532-1.468A4.841,4.841,0,0,1,0,15.354V4.035a3.532,3.532,0,0,1,1.064-2.6A3.506,3.506,0,0,1,3.638.375,3.508,3.508,0,0,1,6.213,1.439a3.529,3.529,0,0,1,1.064,2.6v9.532a2.141,2.141,0,0,1-.681,1.6,2.242,2.242,0,0,1-1.617.659,2.178,2.178,0,0,1-1.6-.659,2.17,2.17,0,0,1-.659-1.6V4.928H4.085v8.638a.854.854,0,0,0,.276.617.875.875,0,0,0,1.277,0,.856.856,0,0,0,.277-.617V4.035a2.209,2.209,0,0,0-.681-1.617,2.209,2.209,0,0,0-1.617-.681,2.139,2.139,0,0,0-1.6.681,2.247,2.247,0,0,0-.66,1.617V15.354A3.632,3.632,0,0,0,5,19.013a3.632,3.632,0,0,0,3.638-3.66V4.928Z",
    transform: "translate(0 -0.375)",
    fill: "#FFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attachment.8ebdc0fc2b7d80674c4fc04d24d63439.svg";